import React from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";

export default function MineActiveContestOverview({ posts }) {
  return (
    <div className =" project-section project-details p-0">
      <div className ="post-details col-md-12">
        <div className ="row active-row">
          <div className ="col-md-12 signup-back">
            <div className ="post-back signup-sec">
              <div className ="col-md-5 overview-left">
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                    alt=""
                  />
                  Job type:
                  {posts?.work_location == 1
                    ? "Virtual"
                    : posts?.work_location == 2
                      ? "Physical"
                      : ""}
                </p>
                <h3>Graphic designer for social media</h3>
                <h1>$20/hr</h1>
              </div>
              <div className =" col-md-4 overview-center">
                <span>About Expert </span>
                <div className ="expert-left pt-2">
                  <img
                    src={`${CloudStorage.cloudurl}//Assets/Images/hireexpert/expert-1.svg`}
                    alt=""
                  />
                  <div>
                    <h2>Carla Carder</h2>
                    <h6>UI Designer </h6>
                    <p>
                      <i className ="fa-solid fa-star"></i> 4.5 (3 jobs)
                    </p>
                  </div>
                </div>
              </div>
              <div className ="col overview-right">
                <button className ="btn submit-work">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/myorders/message-white.svg`}
                    alt=""
                  />
                  Message
                </button>
              </div>
            </div>
          </div>
          <div className ="col-md-4 signup-back">
            <div className ="signup-sec">
              <h4>Logged Hour</h4>
              <h1>145 hrs</h1>
            </div>
          </div>
          <div className ="col-md-4 signup-back">
            <div className ="signup-sec">
              <h4>Approved hour</h4>
              <h1>125 hrs</h1>
            </div>
          </div>
          <div className ="col-md-4 signup-back">
            <div className ="signup-sec">
              <h4>Total payment</h4>
              <h1>$900 of $1,200</h1>
            </div>
          </div>
          <div className ="col-md-12 post-contract">
            <a>
              View post
              <img
                src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                alt=""
              />
            </a>
            <a>
              View contract
              <img
                src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
